import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRadiusTopRight20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconRadiusTopRight20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.226 11v2.484a.75.75 0 0 0 1.5 0V11a8.75 8.75 0 0 0-8.75-8.75h-2.48a.75.75 0 0 0 0 1.5h2.48a7.25 7.25 0 0 1 7.25 7.25M3 7.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2M3 11a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 3.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2M14 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-4.5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2M6 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRadiusTopRight20);
